// extracted by mini-css-extract-plugin
export default {"logoHelvetia":"loginHeading_logoHelvetia__Ombvt","mainText":"loginHeading_mainText__V6iHe"};